<template>
  <v-layout wrap>
    <v-container>
      <v-flex xs12><div class="subheader black--text">Logics</div></v-flex>
      <v-flex xs12 sm6 md12>
        <v-card class="white--text mb-2">
          <v-layout row>
            <v-card-text> 
              <div xs12 class="previous">
                <v-layout class="mb-2">
                  <v-flex xs3 class="black--text">
                    {{ getLogicOperator() }}
                  </v-flex>
                  <v-flex xs3 class="black--text">
                    {{ getInput() }}
                  </v-flex>
                </v-layout>
                
              </div>
            </v-card-text>
          </v-layout>
        </v-card>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: { 
    pre_question_logic: Object,
    operators: [],
    },
  data: () => ({
    // apiUrl: 'project-view',
    // apiUrl: "project-type",
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  created() {
    // this.$store.dispatch("setIndexData", [this.apiUrl]);
    // this.editedData();
    // console.log(this.pre_question_logic);
  },

  methods: {
    getInput(){
      if(this.pre_question_logic.logic_operator_id==6 || this.pre_question_logic.logic_operator_id==7){
        return JSON.parse(this.pre_question_logic.logic_input);
      }else{        
        return this.pre_question_logic.logic_input;
      }
      // console.log(this.questions);
    },
    getLogicOperator(){      
      // console.log(logic);
      return this.operators[this.pre_question_logic.logic_operator_id-1].name;
    },
  },
};
</script>

<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>